import React from 'react'

import { Popover, Tooltip, Icon } from 'antd'
import { get } from 'lodash'

import { getMessage } from '../../util/IntlMessages'

import './styles.css'

// eslint-disable-next-line react/display-name
export default (labelName, props) => {
  const validate = get(props, ['value', '__methods', '__hasValidation'], () => false)
  const renderRequired = validate(props.name || props.field, 'required')

  const FieldRequired = () => (
    <Tooltip title={getMessage('mandatoryField')}>
      <span className="required-asterisk">*</span>
    </Tooltip>
  )

  const InfoIcon = () => (
    <Popover title={props.title} content={props.information}>
      {props.information ? <Icon type={props.icon} /> : ''}
    </Popover>
  )

  return (
    <>
      {labelName + ' '}
      {props.information && <InfoIcon />}
      {renderRequired || props.required ? <FieldRequired /> : <></>}
    </>
  )
}
